import { useRef, useEffect, useState } from "react";
import { TbGalaxy, TbReload } from "react-icons/tb";
import Markdown from "../Markdown/Markdown";
import { HiArrowTurnRightUp, HiStop } from "react-icons/hi2";
import ErrorMessage from "../Components/ErrorMessage";
import { Dropdown } from "react-bootstrap";
import ThreeDotsLoading from "../Loaders/ThreedotsLoading";
import { BiError, BiPlay, BiPlus, BiRocket } from "react-icons/bi";
import Spinner from "../Components/Spinner";
import DeleteItemModal from "../Components/DeleteItemModal";
import { LuTrash2 } from "react-icons/lu";
import { CiCircleAlert, CiCircleCheck } from "react-icons/ci";
import { VscSparkle } from "react-icons/vsc";
import { PiPlugs, PiPlugsConnected } from "react-icons/pi";
import { useParams } from "react-router-dom";
import MandatorySign from "../Components/MandatorySign";
import { useLanguage } from "../Translations/LenguageContext";


const ITEMS_WF = [
    {
        desc: "Create a workflow that automatically triggers when a new lead is added and enriches the contact with AI-generated insights."
    },
    {
        desc: "Build a workflow that monitors incoming emails and routes important customer messages to Slack with a summary."
    },
    {
        desc: "Create a workflow that turns meeting transcripts into structured Notion pages with action items and owners."
    },
    {
        desc: "I want a workflow that schedules follow-up tasks automatically after a sales call based on AI analysis."
    },
    {
        desc: "Build a workflow that detects high-value leads from form submissions and alerts the sales team instantly."
    },
    {
        desc: "Create a workflow that summarizes CRM activity daily and sends a personalized report to each account manager."
    },
    {
        desc: "I want a workflow that automatically tags and categorizes support tickets using AI intent detection."
    },
    {
        desc: "Build a workflow that watches Stripe events and triggers onboarding emails when a customer subscribes."
    },
    {
        desc: "Create a workflow that extracts key insights from documents and stores them in a structured knowledge base."
    },
    {
        desc: "I want a workflow that connects calendar events with task management and auto-generates pre-meeting briefs."
    }
];

const AgentAiChat = ({
    type,
    account_id,
    openAiChat,
    messages,
    chatEndRef,
    handleSendMessage,
    handleStopMessage,
    input,
    setInput,
    handleKeyDown,
    isLoading,
    errorAi,
    chatData,
    setChatId,
    chatId,
    loadingChats,
    loadingChatHistory,
    fetchChatHistory,
    steps,
    fetchSingleChat,
    isSearchEnabled,
    setIsSearchEnabled,
    isAutotestEnabled,
    setIsAutotestEnabled,
    statusMcp,
    inputRef,
    handleInput,
    selectedModel,
    setSelectedModel,
    mcpData,
    setSelectedMcp,
    handleOpenConnect,
    handleOpenDisconnect,
    setOpenErrDepModal,
    fetchMcpData,
    loadingMcpData,
    startRunTest,
    loadingRunTest
}) => {
    const {t} = useLanguage()
    const scrollContainerRef = useRef(null);
    const [showScrollBtn, setShowScrollBtn] = useState(false);
    const [openDeleteItem, setOpenDeleteItem] = useState(false)
    const [selectedItem, setSelectedItem] = useState({})
    const [emptyIndex, setEmptyIndex] = useState(0);

    const handleScroll = () => {
        if (scrollContainerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;

            const isAtBottom = scrollHeight - scrollTop <= clientHeight + 100;

            setShowScrollBtn(!isAtBottom);
        }
    };

    const scrollToBottom = () => {
        setShowScrollBtn(false)
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (chatEndRef?.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [chatEndRef, steps]);

    const fetchNew = () => {
        setChatId(null)
        fetchChatHistory()
    }

    useEffect(() => {
        if (!isLoading && openAiChat) {
            inputRef.current?.focus();
        }
    }, [isLoading, openAiChat]);

    useEffect(() => {
        if (!showScrollBtn) {
            scrollToBottom();
        }
    }, [messages, isLoading]);

    useEffect(() => {
        if (messages.length !== 0) return;

        const interval = setInterval(() => {
            if (type == "MCP") {
                setEmptyIndex((prev) => (prev + 1) % t.abilities.items_mcp.length);
            } else if (type == "WF") {
                setEmptyIndex((prev) => (prev + 1) % ITEMS_WF.length);
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [messages.length]);




    return (
        <div className={`main_mcp_code ${openAiChat ? "main_mcp_code_open" : ""}`}>
            <div className="agent_chat_container_header">
                <p className="agent_chat_container_header_title">
                    AI {type == "MCP" ? "ability" : type == "WF" ? "workflow" : ""} agent
                </p>
                {chatData.length > 0 && (
                    <Dropdown autoClose={"outside"}>
                        <Dropdown.Toggle
                            as="button"
                            type="button"
                            className="agent_chat_container_header_btn fade-in"
                        >

                            <span className="fade-in">
                                {chatData.find((item) => item.id === chatId)?.name || <span className="fade-in">{t.abilities.new_chat}</span>}
                            </span>
                            <i className="fa-solid fa-chevron-down"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="custom_dropdown_menu">

                            <div className="scrollable_dropdown_cont fade-in">
                                {loadingChats ? (
                                    <button className="settings_link">
                                        <Spinner loading={true} />
                                    </button>
                                ) : (
                                    chatData.map((item) => (
                                        <div
                                            className={`settings_link ${chatId == item.id ? "settings_link_selected" : ""}`}
                                            onClick={() => {
                                                setChatId(item.id);
                                                fetchSingleChat(item.id);
                                            }
                                            }
                                        >
                                            <p
                                                key={item.id}
                                                className="settings_link_p"
                                                data-id={item.id}
                                            >
                                                {item.name}
                                            </p>

                                            {loadingChatHistory && chatId == item.id ? (
                                                <button className="remove_file_btn">
                                                    <Spinner loading={true} />
                                                </button>
                                            ) : (
                                                <button
                                                    className="remove_file_btn"
                                                    onClick={() => {
                                                        setSelectedItem(item);
                                                        setOpenDeleteItem(true);
                                                    }}
                                                    title="Delete"
                                                >
                                                    <LuTrash2 />
                                                </button>
                                            )}
                                        </div>
                                    ))

                                )}

                            </div>
                            <div className="dropdown_cont">

                                <button
                                    className="settings_link"
                                    onClick={() => {
                                        setChatId(null);
                                        fetchSingleChat(null)
                                    }
                                    }
                                >
                                    <BiPlus /> {t.abilities.new_chat}
                                </button>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
            <div className="agent_chat_container">
                {messages.length === 0 ? (
                    <div className="empty_chat_wrapper">
                        <div className="empty_chat_interface_mcp">
                            <div className="empty_chat_grid_mcp">
                                <h1 className="empty_chat_interface_title_mcp fade-in">{t.abilities.ask_anything}</h1>
                                <div className="empty_chat_interface_item_mcp">
                                    <p
                                        key={emptyIndex}
                                        className="empty_chat_interface_item_desc fade-in"
                                    >
                                        {type == "MCP" ? (
                                            t.abilities.items_mcp[emptyIndex].desc
                                        ) : type == "WF" ? (
                                            ITEMS_WF[emptyIndex].desc
                                        ) : (
                                            <></>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="chat-wrapper">
                        {/* {loadingChatHistory ? (
                            <ChatLinesLoader search={false} />
                        ) : ( */}
                        <div
                            className="chat_interface_messages_mcp"
                            ref={scrollContainerRef}
                            onScroll={handleScroll}
                        >
                            {messages.map((msg, index) => (
                                <div
                                    key={msg.id}
                                    className={`message_wrapper_mcp fade-in ${msg.sender === "ai" ? "ai_wrapper" : "user_wrapper"}`}
                                >
                                    <div className={`message_bubble ${msg.sender === "ai" ? "ai_bubble" : "user_bubble"}`}>
                                        <div className="message_header">
                                            <span className="message_sender_label">
                                                {msg.sender === "ai" ? msg.model_used : "User"}
                                                {/* {msg.sender === "ai" ? "t0r/omni-t0" : "User"} */}
                                            </span>
                                            <i><TbGalaxy /></i>
                                            <span className="timestamp_message">{msg.timestamp}</span>
                                        </div>
                                        <Markdown msg={msg.text} chatEndRef={chatEndRef} />
                                        {steps &&
                                            Object.keys(steps).length > 0 &&
                                            msg.sender === "ai" &&
                                            index === messages.length - 1 && (
                                                <div className="steps_cont fade-in" chatEndRef={chatEndRef} >
                                                    {Object.entries(steps).map(([stepId, step]) => (
                                                        <div className="steps_item fade-in " key={stepId} >

                                                            <i>
                                                                {step.status === "LOADING" && <Spinner loading={true} />}
                                                                {step.status === "SUCCESS" && <CiCircleCheck />}
                                                                {step.status === "ERROR" && <CiCircleAlert />}
                                                            </i>

                                                            {stepId.startsWith("params") ? (
                                                                <div className="code_params_steps" dangerouslySetInnerHTML={{ __html: step.title }} />
                                                            ) : (
                                                                <p>{step.title}</p>
                                                            )}

                                                        </div>
                                                    ))}

                                                </div>
                                            )}
                                        {isAutotestEnabled && mcpData.version &&  msg.sender === "ai" &&
                                            index === messages.length - 1  && (
                                            <div className="connect_cont">
                                                {loadingMcpData ? (
                                                    <button className="main_mcp_cont_chat_btn main_mcp_cont_chat_btn_loading fade-in">
                                                        <Spinner loading={true} />
                                                    </button>
                                                ) : (
                                                    mcpData.is_connected ? (
                                                        <div className="connect_cont_inner">
                                                            <div className="connect_cont_inner_alert">
                                                                <button
                                                                    className="main_mcp_cont_chat_btn fade-in"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedMcp(mcpData);
                                                                        handleOpenDisconnect(mcpData.system_provider);
                                                                    }}
                                                                >
                                                                    <PiPlugs />
                                                                </button>
                                                                {mcpData.is_version_different && (
                                                                    <span className="version_alert">
                                                                        <MandatorySign message={t.different_version} icon="info" />
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <button className="main_mcp_cont_chat_btn fade-in" onClick={startRunTest} disabled={loadingRunTest}>
                                                                {loadingRunTest ? (
                                                                    <Spinner loading={true} />
                                                                ) : (
                                                                    <>
                                                                        <BiPlay />
                                                                        {t.abilities.runt_test}
                                                                    </>
                                                                )}

                                                            </button>
                                                        </div>
                                                    ) : (
                                                        mcpData.custom_status == "DEPLOYING" ? (
                                                            <button
                                                                className="main_mcp_cont_chat_btn fade-in"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    fetchMcpData()
                                                                }}

                                                            >
                                                                <TbReload />
                                                            </button>
                                                        ) : (
                                                            mcpData.version && (
                                                                <button
                                                                    className="main_mcp_cont_chat_btn fade-in"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedMcp(mcpData);
                                                                        handleOpenConnect(mcpData.system_provider)
                                                                    }}
                                                                >
                                                                    <PiPlugsConnected /> {t.connect}
                                                                </button>
                                                            )
                                                        )
                                                    )
                                                )}
                                            </div>
                                        )}

                                    </div>
                                </div>
                            ))}

                            {isLoading && (
                                <div className="message_wrapper_mcp fade-in">
                                    <div className="message_bubble">
                                        <ThreeDotsLoading />
                                    </div>
                                </div>
                            )}
                            <div className="error_message_chat fade-in">
                                <ErrorMessage err={errorAi} />
                            </div>

                            <div ref={chatEndRef} />
                        </div>
                        {/* )} */}
                        {showScrollBtn && (
                            <button
                                className="scroll_down_btn_chat"
                                onClick={scrollToBottom}
                                type="button"
                            >
                                <i className="fa-solid fa-chevron-down"></i>
                            </button>
                        )}
                    </div>
                )}


                <form className="chat_interface_input" onSubmit={handleSendMessage}>
                    <textarea
                        ref={inputRef}
                        className="chat_input_field"
                        placeholder={t.playground.input_placeholder}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onInput={handleInput}
                        onKeyDown={handleKeyDown}
                        disabled={isLoading}
                        rows={1}
                    />
                    <div className="chat_interface_input_footer">
                        <div className="chat_interface_input_footer_btn_cont">
                            <Dropdown autoClose={"outside"}>
                                <Dropdown.Toggle
                                    as="button"
                                    type="button"
                                    className="more_option_chat no-caret"
                                    id="dropdown-custom-components"
                                >
                                    <i className="fa-solid fa-plus"></i>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="custom_dropdown_menu">

                                    <div className="dropdown_container fade-in">
                                        <div className="settings_link settings_link_actions">
                                            <p>Autotest <MandatorySign message={t.abilities.autotest_warn} icon="info" /></p>
                                            <label className="switch_container">
                                                <input
                                                    id="web-search-toggle"
                                                    type="checkbox"
                                                    checked={isAutotestEnabled}
                                                    onChange={() => setIsAutotestEnabled(!isAutotestEnabled)}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                        {/* <div className="settings_link settings_link_actions">
                                            Web search
                                            <label className="switch_container">
                                                <input
                                                    id="web-search-toggle"
                                                    type="checkbox"
                                                    checked={isSearchEnabled}
                                                    onChange={() => setIsSearchEnabled(!isSearchEnabled)}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div> */}

                                        {/* <div className={`settings_link ${selectedModel == "cerebras/gpt-oss-120b" ? "settings_link_selected" : ""}`} onClick={() => setSelectedModel("cerebras/gpt-oss-120b")}>
                                            gpt-oss-120b
                                        </div>
                                        <div className={`settings_link ${selectedModel == "cerebras/zai-glm-4.7" ? "settings_link_selected" : ""}`} onClick={() => setSelectedModel("cerebras/zai-glm-4.7")}>
                                            zai-glm-4.7
                                        </div> */}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                            {isAutotestEnabled && (
                                <span className={`run_settings_chips_ai ${statusMcp == "DEPLOYING" ? "run_settings_chips_ai_faster" : "run_settings_chips_ai_slower"}`}><i><VscSparkle /></i> Autotest <i className="fa-solid fa-x" onClick={() => setIsAutotestEnabled(false)}></i></span>
                            )}
                            {/* {selectedModel && (
                                <span className="run_settings_chips"><i><VscSparkle /></i> {selectedModel}</span>
                            )} */}
                            {/* {isSearchEnabled && (
                                <span className="run_settings_chips"><i><TbListSearch /></i> Web search <i className="fa-solid fa-x" onClick={() => setIsSearchEnabled(false)}></i></span>
                            )} */}
                        </div>
                        {isLoading ? (
                            <button
                                className="chat_send_button"
                                type="button"
                                onClick={handleStopMessage}
                            >
                                {t.stop} <i><HiStop /></i>
                            </button>
                        ) : (
                            <button
                                className={`chat_send_button ${isLoading || !input.trim() ? "chat_send_button_loading" : ""}`}
                                type="submit"
                                disabled={isLoading || !input.trim()}
                            >
                                {t.send} <i><HiArrowTurnRightUp /></i>
                            </button>
                        )}
                    </div>
                </form>
            </div>
            <DeleteItemModal
                account_id={account_id}
                show={openDeleteItem}
                handleClose={() => setOpenDeleteItem(false)}
                fetchRecords={fetchNew}
                item={selectedItem}
                endpoint={"delete_chat"}
                title={t.chat_history.delete_title}
                description={t.chat_history.delete_warning}
                input_value={selectedItem}
            />
        </div>
    );
};

export default AgentAiChat;